import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b72a3df0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["value", "id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("input", {
    class: _normalizeClass(["input-range", {'disable': _ctx.isDisable}]),
    ref: "input",
    type: "range",
    min: "0",
    max: "1",
    step: "0.1",
    name: "range",
    value: _ctx.volumeValue,
    id: _ctx.id,
    onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.getRange && _ctx.getRange(...args)))
  }, null, 42, _hoisted_1))
}